import { FC, FormEvent, useMemo, useState } from 'react'
import { InputProps } from './Input.d'

const Input: FC<InputProps> = ({ label, type, name }) => {
  const [value, setValue] = useState('')
  const onChange = (e: FormEvent<HTMLInputElement>) =>
    setValue(e.currentTarget.value)

  const classes = useMemo(() => {
    if (value && value.trim()) {
      return 'border-teal'
    }

    return 'border-white'
  }, [value])

  return (
    <div className="relative">
      <input
        id={name}
        type={type}
        name={name}
        className={`peer h-10 w-full border-b-2 placeholder-transparent focus:outline-none focus:border-teal bg-transparent appearance-none ${classes}`}
        placeholder=" "
        required
        onChange={onChange}
      />
      <label
        htmlFor={name}
        className="absolute left-0 -top-3.5 text-sm transition-all peer-placeholder-shown:text-base peer-placeholder-shown:top-2 peer-focus:-top-3.5 peer-focus:text-sm"
      >
        {label}
      </label>
    </div>
  )
}

export default Input
